import { registerPlugin } from '@capacitor/core'

import type { AndroidSafeAreaPlugin } from './definitions'

const AndroidSafeArea = registerPlugin<AndroidSafeAreaPlugin>('AndroidSafeArea', {})

export * from './definitions'
export { AndroidSafeArea }
